define('OutSystems/ClientRuntime/modules/LocaleService/LocaleService',["require", "exports", "tslib", "../../ApplicationInfo", "../../Injector", "../../Injector/KnownServices", "../../StorageProvider", "../PubSub/Publisher"], function (require, exports, tslib_1, ApplicationInfo, Injector, KnownServices_1, StorageProvider_1, Publisher_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DEFAULT_LOCALE = "en-US";
    var LOCALE_SEPARATOR = "-";
    var DEFAULT_RTL = false;
    var MODULE_NAME = "Locale Service";
    var LOCALE_KEY = "CurrentLocale";
    var LOCALE_EXPRESSION = /^[A-z]{2,3}([_-]([A-z]{4}|[\d]{3}))?([_-]([A-z]{2}|[\d]{3}))?$/;
    var LocaleService = (function () {
        function LocaleService(applicationName) {
            this.currentLocaleStorage = new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, LOCALE_KEY, null, ApplicationInfo.getUserProviderName);
            this.publisher = new Publisher_1.default(MODULE_NAME, applicationName);
        }
        LocaleService.prototype.subscribe = function (handler) {
            return this.publisher.subscribe(handler);
        };
        LocaleService.prototype.unsubscribe = function (handler) {
            return this.publisher.unsubscribe(handler);
        };
        LocaleService.prototype.getCurrentLocale = function () {
            var _a, _b;
            return (_b = (_a = this.getStoredLocale()) === null || _a === void 0 ? void 0 : _a.localeCode) !== null && _b !== void 0 ? _b : DEFAULT_LOCALE;
        };
        LocaleService.prototype.setCurrentLocale = function (localeCode) {
            var translationsService = Injector.resolve(KnownServices_1.ServiceNames.TranslationsService);
            if (translationsService) {
                translationsService.clear();
            }
            if (this.isValidLocale(localeCode)) {
                var locale = {
                    localeCode: localeCode,
                    isRTL: DEFAULT_RTL,
                };
                this.currentLocaleStorage.set(locale);
            }
            else {
                throw new Error("Value '" + localeCode + "' isn't a valid locale.");
            }
            var localeFamily = this.getCurrentLocaleFamily();
            this.publisher.publish({ localeCode: localeCode, localeFamily: localeFamily });
        };
        LocaleService.prototype.getCurrentLocaleFamily = function () {
            var _a;
            var result = [];
            var localeCode = (_a = this.getCurrentLocale()) !== null && _a !== void 0 ? _a : "";
            var hasParentLocale = localeCode.indexOf(LOCALE_SEPARATOR) > 0;
            if (hasParentLocale) {
                result.push(localeCode.split(LOCALE_SEPARATOR)[0]);
            }
            result.push(localeCode);
            return result;
        };
        LocaleService.prototype.isValidLocale = function (locale) {
            return LOCALE_EXPRESSION.test(locale);
        };
        LocaleService.prototype.isCurrentLocaleRTL = function () {
            var _a, _b;
            return (_b = (_a = this.getStoredLocale()) === null || _a === void 0 ? void 0 : _a.isRTL) !== null && _b !== void 0 ? _b : DEFAULT_RTL;
        };
        LocaleService.prototype.setCurrentLocaleRTL = function (isRTL) {
            var _a;
            var locale = (_a = this.getStoredLocale()) !== null && _a !== void 0 ? _a : { localeCode: DEFAULT_LOCALE, isRTL: DEFAULT_RTL };
            if (typeof locale === "string") {
                this.currentLocaleStorage.set({ localeCode: locale, isRTL: isRTL });
            }
            else {
                this.currentLocaleStorage.set(tslib_1.__assign(tslib_1.__assign({}, locale), { isRTL: isRTL }));
            }
        };
        LocaleService.prototype.getStoredLocale = function () {
            var locale = this.currentLocaleStorage.get();
            if (typeof locale === "string") {
                return { localeCode: locale, isRTL: DEFAULT_RTL };
            }
            else {
                return locale;
            }
        };
        return LocaleService;
    }());
    exports.default = LocaleService;
});
//# sourceMappingURL=LocaleService.js.map;
